const COMMISSION_RATE_RECOMMENDED = 0.18;
const COMMISSION_RATE_PERCENTAGE_URGENT = 0.5;
const COMMISSION_RATE_PERCENTAGE_NON_URGENT = 0.3;
const MIN_COMMISSION = 2000;
export const COMMISSION_RATE_MIN = 0.1;
export const COMMISSION_RATE_MAX = 0.5;

export const RECOMMENDED_COMMISSION_RATE_PERCENTAGE = 0.18;
export const RECOMMENDED_BOUNTY_PERCENTAGE_URGENT = 0.5;
export const RECOMMENDED_BOUNTY_PERCENTAGE_NON_URGENT = 0.3;

export const getPriceInfo = ({
  bounty,
  salaryMin,
  salaryMax,
  isUrgent,
  commissionRate,
}: {
  bounty: number;
  salaryMin: number;
  salaryMax: number;
  isUrgent: boolean;
  commissionRate?: number;
}) => {
  const salaryAverage = (+salaryMin + +salaryMax) / 2;
  const bountyCommissionRate = bounty / salaryAverage;

  const commissionRateIsTooLow = commissionRate && commissionRate <= COMMISSION_RATE_MIN;
  const bountyIsTooLow = bounty < MIN_COMMISSION;

  const commissionRateRangeIsTooLow = (commissionRate || 0) < COMMISSION_RATE_MIN * 100;
  const commissionRateRangeIsTooHigh = (commissionRate || 0) > COMMISSION_RATE_MAX * 100;
  const commissionRateIsWithinRecommended = (commissionRate || 0) >= COMMISSION_RATE_RECOMMENDED * 100;

  const commissionRateIsInRange = !commissionRateRangeIsTooLow && !commissionRateRangeIsTooHigh;
  const commissionRateMin = isUrgent ? COMMISSION_RATE_PERCENTAGE_URGENT : COMMISSION_RATE_PERCENTAGE_NON_URGENT;
  const commissionRateValueMin = ((commissionRate || 0) / 100) * commissionRateMin;

  const bountyRecommended = salaryAverage * commissionRateValueMin;
  const bountyCommissionRateIsTooLow = bounty < bountyRecommended;

  return {
    bounty,
    salaryMin,
    salaryMax,
    isUrgent,
    commissionRate,
    salaryAverage,
    bountyCommissionRate,
    commissionRateMin,
    commissionRateIsWithinRecommended,
    commissionRateValueMin,
    commissionRateIsTooLow,
    commissionRateRangeIsTooLow,
    commissionRateRangeIsTooHigh,
    bountyIsTooLow,
    commissionMin: MIN_COMMISSION,
    commissionRateRecommended: COMMISSION_RATE_RECOMMENDED,
    commissionRateIsInRange,
    bountyCommissionRateIsTooLow,
    bountyRecommended,
  };
};

export const getBountyRecommandation = ({
  salaryMin,
  salaryMax,
  isUrgent,
}: {
  bounty: number;
  salaryMin: number;
  salaryMax: number;
  isUrgent: boolean;
  commissionRate?: number;
}) => {
  const salaryAverage = (+salaryMin + +salaryMax) / 2;

  const recommendedBountyPerceivedByRecruiterPercentage = RECOMMENDED_COMMISSION_RATE_PERCENTAGE;
  const recommendedBountyPerceivedByRecruiter = salaryAverage * recommendedBountyPerceivedByRecruiterPercentage;

  const recommendedBountySharePercentage = isUrgent ? RECOMMENDED_BOUNTY_PERCENTAGE_URGENT : RECOMMENDED_BOUNTY_PERCENTAGE_NON_URGENT;
  const recommendedBounty = recommendedBountyPerceivedByRecruiter * recommendedBountySharePercentage;

  return {
    recommendedCommissionRate: COMMISSION_RATE_RECOMMENDED,
    salaryAverage,
    recommendedBountySharePercentage,
    recommendedBountyPerceivedByRecruiterPercentage,
    recommendedBountyPerceivedByRecruiter,
    recommendedBounty,
  };
};
